import styles from './styles.module.scss';

type Props = {
  className?: string;
};

/**
 * セクション間の区切り線コンポーネント。
 * Design System の `Admin / Divider` に対応する 1px 水平罫線。
 *
 * @param className - 追加の CSS クラス名
 */
export const Divider: React.FC<Props> = ({ className }) => (
  <hr className={[styles.divider, className].filter(Boolean).join(' ')} />
);
